/**
 * Bareme de l'impot sur le revenu, year-versioned.
 *
 * Every constant here is transcribed from the cited official source, never
 * from recall. Adding a year means adding one entry to BAREMES; nothing else
 * changes. See docs/superpowers/specs/2026-07-16-reports-tax-design.md.
 */
const BAREME_2026 = {
    year: 2026,
    brackets: [
        { upToCents: 1_160_000, ratePct: 0 },
        { upToCents: 2_957_900, ratePct: 11 },
        { upToCents: 8_457_700, ratePct: 30 },
        { upToCents: 18_191_700, ratePct: 41 },
        { upToCents: null, ratePct: 45 },
    ],
    plafondQfPerHalfPartCents: 180_700,
    plafondQfParentIsoleFirstChildCents: 426_200,
    decote: {
        ceilingSingleCents: 198_200,
        ceilingCoupleCents: 327_700,
        baseSingleCents: 89_700,
        baseCoupleCents: 148_300,
        ratePct: 45.25,
    },
    abattement: {
        bncPct: 34,
        bicServicesPct: 50,
        bicVentePct: 71,
        minCents: 30_500,
    },
    source: "https://bofip.impots.gouv.fr/bofip/14954-PGP.html/ACTU-2026-00022",
    law: "loi n° 2026-103 du 19 février 2026 de finances pour 2026, art. 4, I-A et B",
};
const BAREMES = {
    2026: BAREME_2026,
};
export const LATEST_BAREME_YEAR = Math.max(...Object.keys(BAREMES).map(Number));
/**
 * Resolve the bareme for a year, falling back to the most recent one at or
 * below it.
 *
 * The bareme for year N lands in the loi de finances around late December, so
 * every January this is asked for a year it does not have. Refusing would
 * blank the feature annually; brackets are inflation-indexed (+0,9% for 2026)
 * so the prior year estimates within ~1%. It never refuses, and never silently
 * pretends: callers get isEstimateFromPriorYear and must show it.
 */
export function baremeFor(year) {
    const exact = BAREMES[year];
    if (exact)
        return { bareme: exact, requestedYear: year, isEstimateFromPriorYear: false };
    const earlier = Object.keys(BAREMES)
        .map(Number)
        .filter((y) => y < year)
        .sort((a, b) => b - a)[0];
    if (earlier !== undefined) {
        return { bareme: BAREMES[earlier], requestedYear: year, isEstimateFromPriorYear: true };
    }
    // Year predates every encoded bareme: use the oldest we have.
    const oldest = Math.min(...Object.keys(BAREMES).map(Number));
    return { bareme: BAREMES[oldest], requestedYear: year, isEstimateFromPriorYear: true };
}
//# sourceMappingURL=bareme.js.map